import SwitchTabs from './SwitchTabs'
export * from './SwitchTabs'

export default SwitchTabs
